export const carbonAnalysisMessages = [
    "💨 Calculating carbon footprint...",
    "🌳 Assessing carbon sequestration...",
    "🏭 Monitoring emissions data...",
    "📈 Projecting carbon trends...",
    "🌍 Validating carbon credits...",
    "📊 Analyzing carbon offset potential...",
    "💡 Optimizing carbon reduction strategies...",
    "🌱 Quantifying reforestation impact...",
    "🔬 Evaluating soil carbon content...",
    "🌬️ Modeling atmospheric carbon...",
    "📉 Identifying emission hotspots...",
    "♻️ Tracing supply chain emissions...",
    "💰 Estimating carbon market value...",
    "📜 Verifying carbon project compliance...",
    "☀️ Assessing renewable energy impact...",
    "🚜 Analyzing agricultural carbon practices...",
    "🌊 Monitoring oceanic carbon absorption...",
    "🔥 Simulating wildfire carbon release...",
    "🏙️ Urban carbon footprint mapping...",
    "🌐 Global carbon cycle analysis...",
];

export const biodiversityAnalysisMessages = [
    "🌿 Calculating Biodiversity Intactness Index...",
    "🧬 Computing Mean Species Abundance...",
    "📉 Estimating Potential Disappearance Fraction...",
    "🐦 Identifying and classifying bird species...",
    "🐾 Tracking terrestrial wildlife populations...",
    "💧 Assessing aquatic ecosystem health...",
    "🌸 Mapping native and invasive plant species...",
    "🦋 Monitoring pollinator activity and diversity...",
    "🦊 Evaluating habitat connectivity and fragmentation...",
    "🌲 Analyzing forest ecosystem resilience...",
    "🦉 Detecting nocturnal species and their calls...",
    "🐢 Monitoring endangered and migratory species...",
    "🌍 Assessing ecosystem services and biodiversity trends...",
  ];

export const environmentalAnalysisMessages = [
    "🌍 Monitoring climate changes...",
    "🛰️ Analyzing satellite imagery...",
    "💧 Assessing water quality...",
    "🌬️ Measuring air pollution...",
    "🌡️ Tracking climate indicators...",
    "🏞️ Evaluating land degradation...",
    "⚡ Analyzing energy consumption...",
    "🗑️ Waste management impact...",
    "☢️ Radiation level assessment...",
    "🔊 Noise pollution mapping...",
    "🚜 Soil health and erosion...",
    "🌊 Ocean current and temperature...",
    "🌋 Volcanic activity monitoring...",
    "🧊 Glacier and ice cap melt...",
    "🌪️ Extreme weather pattern analysis...",
    "💡 Renewable resource potential...",
    "🧪 Chemical contaminant detection...",
    "🏙️ Urban heat island effect...",
    "🗺️ Geospatial risk assessment...",
    "🌐 Global climate trend analysis...",
];
